const ELLIPSIS_LENGTH = 34;
export const addEllipsis = (text, length = ELLIPSIS_LENGTH) => {
  return (text || "").length > ELLIPSIS_LENGTH ? `${text.substr(0, length)}...` : text;
};
